import { render, staticRenderFns } from "./GroupChatBubbleText.vue?vue&type=template&id=a72e7812&"
import script from "./GroupChatBubbleText.vue?vue&type=script&lang=js&"
export * from "./GroupChatBubbleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports